import AxiosService from './AxiosService';

class MachineLearningService {
  constructor() {
    if (!MachineLearningService.instance) {
      MachineLearningService.instance = this;
    }
    return MachineLearningService.instance;
  }

  serviceEndpoint = 'ml';

  getNewChatSession = async (taskType, context, options) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/chat/session/`,
      { task_type: taskType, context },
      options
    );
    return response.data;
  };

  createNewChatSession = async (taskType, context, options) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/chat/new/`,
      { task_type: taskType, context },
      options
    );
    return response.data;
  };

  getChatHistory = async (id, options) => {
    const response = await AxiosService.get(
      `${this.serviceEndpoint}/chat/${id}/`,
      {
        ...options,
      }
    );
    return response.data;
  };

  cancelChatSession = async (id, options) => {
    return AxiosService.patch(
      `${this.serviceEndpoint}/chat/${id}/cancel/`,
      options
    );
  };

  completeChatSession = async (id, options) => {
    return AxiosService.get(
      `${this.serviceEndpoint}/chat/${id}/start-action/`,
      options
    );
  };

  getChatMetadata = async (options) => {
    const response = await AxiosService.get(
      `${this.serviceEndpoint}/chat/metadata/`,
      options
    );
    return response.data;
  };

  sendMessage = async (id, payload, options) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/chat/${id}/send-message/`,
      payload,
      options
    );
    return response.data;
  };

  getStreamingEndpoint = (id) => {
    return `${import.meta.env.VITE_API_BASE_PATH}/${this.serviceEndpoint}/chat/${id}/send-message-streaming/`;
  };

  getStartFlowStreamingEndpoint = (id) => {
    return `${import.meta.env.VITE_API_BASE_PATH}/${this.serviceEndpoint}/chat/${id}/start-flow/`;
  };

  getRetryStreamingEndpoint = (id) => {
    return `${import.meta.env.VITE_API_BASE_PATH}/${this.serviceEndpoint}/chat/${id}/retry/`;
  };

  startAction = async (taskType) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/actions/start/`,
      {
        params: { task_type: taskType },
      }
    );
    return response.data;
  };

  startFlow = async (payload, options) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/flow/start/`,
      payload,
      options
    );
    return response.data;
  };

  newFlow = async (payload, options) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/flow/new/`,
      payload,
      options
    );
    return response.data;
  };

  startSubFlow = async (chatId) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/chat/${chatId}/start-flow/`
    );
    return response.data;
  };

  getFlowStatus = async ({
    flowType,
    objectId = '',
    chatSessionId = '',
    flowId = '',
    options = {},
  }) => {
    const params = {
      type: flowType,
      ...(chatSessionId && { session_id: chatSessionId }),
      ...(objectId && { target_object_id: objectId }),
      ...(flowId && { flow_id: flowId }),
    };

    const response = await AxiosService.get(
      `${this.serviceEndpoint}/flow/last/`,
      {
        params,
        ...options,
      }
    );
    return response.data;
  };

  createChatFlag = async ({ chatId, tag, reason, options }) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/chat/${chatId}/flag/`,
      { tag, reason },
      options
    );
    return response.data;
  };

  createFlowFlag = async ({ flowId, tag, reason, options }) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/flow/${flowId}/flag/`,
      { tag, reason },
      options
    );
    return response.data;
  };

  retryChatMessage = async (chatSessionId, options) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/chat/${chatSessionId}/retry/`,
      {},
      options
    );
    return response.data;
  };

  getChatSessionHistories = async (taskType, page = 1, options) => {
    const response = await AxiosService.get(
      `${this.serviceEndpoint}/chat/histories/`,
      { params: { task_type: taskType, page }, ...options }
    );
    return response.data;
  };

  deleteChatSession = async (id, options) => {
    return AxiosService.patch(
      `${this.serviceEndpoint}/chat/${id}/cancel`,
      options
    );
  };
}

const instance = new MachineLearningService();
Object.freeze(instance);

export default instance;
